<template>
  <div class="container-fluid ib-auth-bg">
    <div class="row">
      <div class="col-md-4 offset-md-4 px-5">
        <div class="jbl-otp-h-right jbl-otp-right">

          <div class="text-center d-block my-5">
            <router-link :to="{ name: 'Home' }">
              <img alt="Logo Icon" class="img-fluid in-fluid-70" :src="require('@/assets/images/ib-logo.svg')" />
            </router-link>
          </div>

          <h5 class="ib-auth-desc" style="">Please update or continue<br> with the same Username</h5>
          <form @submit.prevent="submitUsername" id="UsernameForm">
            <div>
              <div class="jbl-field-sign jbl-otp-field">
                <label class="jbl-label-sign">Username</label>
                <input class="ib-login-input" type="text" placeholder="Username" v-model="username" required pattern="[a-zA-Z0-9]+" title="Only Alphabets And Numbers"/>
              </div>

              <div v-if="errors.filter(x => x.field == 'username').length > 0">
                <div class="d-block jbl-text-danger">
                  <small class="text-danger">{{errors.filter(x => x.field == 'username')[0].message}}</small>
                </div>
              </div>
            </div>
            <div class="d-block text-center">
              <button type="submit" class="ib-btn-primary ib-btn-hover ib-btn-width mt-4">Submit</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'UsernameVerification',
    data () {
      return {
        username: this.$store.getters.getUsername,
        errors: []
      }
    },
    created () {
      const self = this;
      if(self.$store.getters.isAuthenticated && self.$store.getters.isUsernameVerified) {
        self.$router.push({ name: 'Home' });
      }
      if(!self.$store.getters.isAuthenticated) {
        self.$store.commit("resetState");
        window.location.reload();
      }
    },
    methods: {
      submitUsername () {
        const self = this;
        self.errors = [];

        if(self.username.length < 5 || self.username.length > 50) {
          self.errors.push({
            field: 'username',
            message: 'Username length must be between 5 and 50'
          });
        }

        if (self.errors.length > 0) {
          return false;
        }

        var formData = new FormData();
        formData.append('username', self.username);

        axios.post('customer/username_verification', formData).then(function (resp) {
          if (resp.data.code == 200) {
            self.$store.commit('setUsernameVerified');
            self.$store.commit('setUsername', self.username);
            $toast.success('Username Set Successfully!!', { position: 'top-right' });
            self.$router.push({ name: 'Home' });
          }
        }).catch(function (error) {
          if(error.response) {
            error.response.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.data.message, { position: 'top-right' });
          }
        });
      },
    }
  }
</script>

<style scoped>
  .container-fluid {
    background-repeat: no-repeat;
    height: 100%;
    position: fixed;
  }

  .left-area {
    text-align: center;
  }
  .jbl-sign-left.jbl-otp-h h1 {
    font-size: 50px;
  }

  .jbl-otp-flex {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
  }

  .jbl-field.jbl-otp-field {
    margin-left: 4rem;
    margin-top: 1rem;
  }

  @media (max-width:450px) {
    .jbl-otp-field {
      min-width: 300px !important;
    }
  }
  @media (min-width:451px) {
    .jbl-otp-field {
      min-width: 380px !important;
    }
  }
  .jbl-otp-right h5 {
    font-family: "Futura PT Medium";
    font-size: 25px;
    font-weight: 500;
    line-height: 1.28;
    color: #5b6770;
  }
  @media(max-width:550px){
  .jbl-otp-right h5{
    font-size: 15px !important;
    font-family: "Futura PT Medium";
    font-weight: 500;
    line-height: 1.28;
    color: #5b6770;
  }
  .in-fluid-70{
    max-width: 70% !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Auth/UsernameVerification.vue